import { Component, OnInit} from '@angular/core';
import { CalendarDate} from '../../../_components/calendar-widget/calendar-widget.component';
import * as moment from 'moment';
import { NivelacionesService} from '../_services/nivelaciones.service';
import { ActivatedRoute, Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { NivelacionesEspecialesAlumnosComponent} from '../nivelaciones-especiales-alumnos/nivelaciones-especiales-alumnos.component';
import { EstudioService} from '../../estudio/estudio.service';
import { CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';

@Component({
  selector: 'nivelaciones-especiales',
  standalone: false,
  templateUrl: 'nivelaciones-especiales.component.html',
  styleUrls: [
    '../nivelaciones-alumnos/nivelaciones-alumno.component.scss',
    '../citacion-materia-curso/citacion-materia-curso.component.scss',
    '../../estudio/materias-familia/materia-unidades/materia-unidades.component.scss']
})

export class NivelacionesEspecialesComponent implements OnInit {
  displayedColumns = ['alumno', 'materia-curso', 'franja', 'asistencia'];
  dataSource: MatTableDataSource<any>;

  fechaSeleccionada: string;
  mFechaSel: moment.Moment;
  fechaCalendar: CalendarDate;
  initialDateMateria: moment.Moment;
  endDateMateria: moment.Moment;

  listBloqueados: any[];
  enabledButton = false;

  constructor(public route: ActivatedRoute,
              public router: Router,
              public dialog: MatDialog,
              public snackBar: MatSnackBar,
              public customAlertService: CustomAlertService,
              public nivelacionesService: NivelacionesService,
              public estudioService: EstudioService) {
  }

  ngOnInit() {
    this.fechaSeleccionada = this.route.snapshot.paramMap.get('fecha');
    if (!this.fechaSeleccionada) {
      this.fechaSeleccionada = moment().format('YYYY-MM-DD');
    }

    this.mFechaSel = moment(this.fechaSeleccionada);
    this.nivelacionesService.getNivelacionesEspeciales(this.fechaSeleccionada).subscribe(res => {
      const data = this.nivelacionesService.extractData(res);
      this.enabledButton = data.enable;
      this.dataSource = new MatTableDataSource<any>(data.nivelaciones);
    });

    this.fechaCalendar = {mDate: moment(this.fechaSeleccionada), selected: true};
    this.initialDateMateria = moment('2018-08-08', 'YYYY-MM-DD');
    this.endDateMateria = moment('2019-07-08', 'YYYY-MM-DD');

    this.nivelacionesService.getExcepcionesEspeciales().subscribe(res => {
      this.listBloqueados = this.nivelacionesService.extractData(res);
      this.listBloqueados = this.listBloqueados.map(fecha => {
        fecha = moment(fecha.substring(0, 10));
        return fecha;
      });
    }, err => {
      console.error(err);
    });

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  filtroTexto(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  changeDate(date) {
    this.router.navigate(['/', 'nivelaciones', 'especiales', 'fecha', date.mDate.format('YYYY-MM-DD')]);
  }

  addAlumnos() {
    const dialogRef = this.dialog.open(NivelacionesEspecialesAlumnosComponent, {
      width: '70%',
      height: '70%',
      disableClose: true,
      data: {'fecha': this.fechaSeleccionada}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = this.dataSource.data;
        data = data.concat(result);

        data.sort((a, b) => {
          const textoA = a.alumno.toLowerCase(),
            textoB = b.alumno.toLowerCase();
          return (textoA < textoB) ? -1 : (textoA > textoB) ? 1 : 0;
        });
        this.dataSource = new MatTableDataSource<any>(data);
      }
    });
  }

  timer;

  setAsistencia(estado, elemento) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    // let fechaInd = elemento.fechas.findIndex(fecha => fecha.fecha == idFecha),
    //   modelo = Object.assign({}, elemento.fechas[fechaInd]);

    // modelo.ausente = false;
    // modelo.retardo = false;
    elemento.ausente = false;
    elemento.retardo = false;
    elemento.presente = false;
    elemento.noReportaAsistencia = false;

    elemento[estado] = true;

    this.timer = setTimeout(() => {
      this.estudioService.setEstadoAsistenciaNivelacion(elemento).subscribe(res => {
        this.snackBar.open(`La asistencia del alumno se actualizó correctamente.`, null, {duration: 2500});
      }, err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible actualizar la asistencia. <br> ${err.error} Código de error: ${err.statusText}`
        });
      });
    }, 500);
  }

  cambiarCitacion(evt, fecha, alumnoID, horaID) {
    const modelo = Object.assign({}, fecha.value);
    modelo['alumnoID'] = alumnoID;
    modelo['hora'] = horaID;
    modelo.citado = evt.checked;

    this.estudioService.setEstadoCitacionNivelacion(modelo).subscribe(res => {
      this.snackBar.open(`Citación ${modelo.citado ? 'realizada' : 'eliminada'} correctamente.`, null, {duration: 2500});
      fecha.value.id = res['id'];
    }, err => {
      fecha.citado = !evt.checked;
      evt.source._checked = !evt.checked;
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible realizar la acción. <br> ${err.error} Código de error: ${err.statusText}`
      });
    });
  }

  eliminarCitacion(elemento) {
    let data = this.dataSource.data;
    elemento.citado = false;
    this.estudioService.eliminarNivelacionEspecial(elemento).subscribe(res => {
      this.snackBar.open(`Citación eliminada correctamente.`, null, {duration: 2500});
      data = data.filter(dataElement => {
        return dataElement.id !== elemento.id;
      });
      this.dataSource = new MatTableDataSource<any>(data);
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible realizar la acción. <br> ${err.error} Código de error: ${err.statusText}`
      });
    });
  }
}
